import { renderLocationSidebar } from './locationSidebar';

export const CREATE_ROUTE_TEMPLATE = `
<div class="flex min-h-screen bg-background-light">
${renderLocationSidebar('routes')}
<main class="ml-64 flex-1 text-slate-900 min-w-0">
  <div class="max-w-[1440px] mx-auto p-6 lg:p-10">
    <div id="create-route-alert" class="hidden mb-6 items-start gap-4 p-4 rounded-xl border bg-rose-50 border-rose-200">
      <span class="material-symbols-outlined text-rose-600">error</span>
      <div>
        <p class="text-sm font-semibold text-rose-800" id="create-route-alert-title">Request failed</p>
        <p class="text-sm text-rose-700 opacity-80" id="create-route-alert-text">Please review form fields.</p>
      </div>
    </div>

    <div class="mb-8">
      <nav class="flex items-center gap-2 text-sm text-slate-500 mb-2">
        <a class="hover:text-primary" href="/dashboard">Dashboard</a>
        <span class="material-symbols-outlined text-xs">chevron_right</span>
        <a class="hover:text-primary" href="/routes">Routes</a>
        <span class="material-symbols-outlined text-xs">chevron_right</span>
        <span class="text-slate-900 font-medium">Edit Route</span>
      </nav>
      <div class="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 class="text-3xl font-extrabold tracking-tight text-slate-900">Route Editor</h1>
          <p class="text-slate-500 mt-1">Create or edit route with all details from one screen.</p>
        </div>
        <div class="flex items-center gap-3">
          <span class="px-3 py-1 rounded-full bg-amber-100 text-amber-700 text-sm font-semibold flex items-center gap-1">
            <span class="size-2 bg-amber-500 rounded-full"></span> Draft
          </span>
        </div>
      </div>
    </div>

    <form id="create-route-form" class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start pb-28">
      <div class="lg:col-span-7 space-y-8">
        <section class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <div class="flex items-center gap-2 mb-6 border-b border-slate-100 pb-4">
            <span class="material-symbols-outlined text-primary">info</span>
            <h3 class="text-lg font-bold">General Information</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="md:col-span-2">
              <label class="block text-sm font-semibold text-slate-700 mb-2">Route Title</label>
              <input id="route-title" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2" type="text"/>
            </div>
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-2">Slug</label>
              <div class="flex">
                <span class="inline-flex items-center px-3 rounded-l-lg border border-r-0 border-slate-200 bg-slate-100 text-slate-500 text-sm">motojourney.com/</span>
                <input id="route-slug" class="flex-1 min-w-0 bg-slate-50 border-slate-200 rounded-r-lg focus:border-primary focus:ring-primary text-sm px-3 py-2" type="text"/>
              </div>
            </div>
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-2">Location Name</label>
              <input id="route-location-name" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2" type="text"/>
            </div>
            <div class="md:col-span-2">
              <label class="block text-sm font-semibold text-slate-700 mb-2">Description</label>
              <textarea id="route-description" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2" rows="4"></textarea>
            </div>
            <div class="md:col-span-2">
              <label class="block text-sm font-semibold text-slate-700 mb-2">Structured Content (blocks_v1)</label>
              <div id="route-content-blocks-editor" class="rounded-lg border border-slate-200 bg-white p-3"></div>
              <textarea id="route-content-blocks" class="hidden" rows="1"></textarea>
            </div>
          </div>
        </section>

        <section class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <div class="flex items-center gap-2 mb-6 border-b border-slate-100 pb-4">
            <span class="material-symbols-outlined text-primary">analytics</span>
            <h3 class="text-lg font-bold">Metrics & Classification</h3>
          </div>
          <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
            <div>
              <label class="block text-xs font-bold uppercase text-slate-500 mb-1.5">Distance (km)</label>
              <input id="route-distance-km" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2" type="number" min="0" step="0.1"/>
            </div>
            <div>
              <label class="block text-xs font-bold uppercase text-slate-500 mb-1.5">Duration (min)</label>
              <input id="route-duration-minutes" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2" type="number" min="0"/>
            </div>
            <div>
              <label class="block text-xs font-bold uppercase text-slate-500 mb-1.5">Elev. Gain (m)</label>
              <input id="route-elevation-gain" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2" type="number" min="0"/>
            </div>
            <div>
              <label class="block text-xs font-bold uppercase text-slate-500 mb-1.5">Elev. Loss (m)</label>
              <input id="route-elevation-loss" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2" type="number" min="0"/>
            </div>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="md:col-span-2">
              <label class="block text-sm font-semibold text-slate-700 mb-2">Difficulty</label>
              <select id="route-difficulty" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2">
                <option value="">Select difficulty</option>
              </select>
            </div>
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-2">Categories</label>
              <select id="route-categories" multiple class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2 min-h-[112px]"></select>
            </div>
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-2">Tags</label>
              <select id="route-tags" multiple class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2 min-h-[112px]"></select>
            </div>
            <div class="md:col-span-2 flex items-center justify-between p-4 bg-primary/5 rounded-lg border border-primary/20">
              <div>
                <h4 class="text-sm font-bold text-slate-900">Featured Route</h4>
                <p class="text-xs text-slate-500">Promote this route on the home page and discovery feed.</p>
              </div>
              <label class="relative inline-flex items-center cursor-pointer">
                <input id="route-is-featured" class="sr-only peer" type="checkbox"/>
                <div class="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
              </label>
            </div>
          </div>
        </section>

        <section class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm overflow-hidden">
          <div class="flex items-center justify-between mb-6 border-b border-slate-100 pb-4">
            <div class="flex items-center gap-2">
              <span class="material-symbols-outlined text-primary">add_location_alt</span>
              <h3 class="text-lg font-bold">Waypoints Builder</h3>
            </div>
            <button id="route-waypoint-add-btn" class="flex items-center gap-1 text-primary text-sm font-bold hover:underline" type="button">
              <span class="material-symbols-outlined text-base">add</span>
              Add Waypoint
            </button>
          </div>
          <p class="text-xs text-slate-500 mb-4 bg-slate-50 p-2 rounded italic">
            <span class="material-symbols-outlined text-sm align-middle mr-1">info</span>
            Add and edit route points in order.
          </p>
          <div class="overflow-x-auto">
            <table class="w-full text-left border-collapse">
              <thead>
                <tr class="text-xs font-bold uppercase text-slate-500 border-b border-slate-100">
                  <th class="pb-3 px-2">#</th>
                  <th class="pb-3 px-2">Type</th>
                  <th class="pb-3 px-2">Latitude</th>
                  <th class="pb-3 px-2">Longitude</th>
                  <th class="pb-3 px-2">Title</th>
                  <th class="pb-3 px-2">Location</th>
                  <th class="pb-3 px-2">Note</th>
                  <th class="pb-3 w-10"></th>
                </tr>
              </thead>
              <tbody id="route-waypoints-body" class="divide-y divide-slate-100"></tbody>
            </table>
          </div>
        </section>

        <section class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <div class="flex items-center gap-2 mb-6 border-b border-slate-100 pb-4">
            <span class="material-symbols-outlined text-primary">gavel</span>
            <h3 class="text-lg font-bold">Moderation & Review</h3>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-2">Status</label>
              <select id="route-status" class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2">
                <option value="draft">Draft</option>
                <option value="pending_review">Pending Review</option>
                <option value="approved">Approved</option>
                <option value="published">Published</option>
                <option value="rejected">Rejected</option>
                <option value="archived">Archived</option>
              </select>
            </div>
            <div class="md:col-span-2">
              <label class="block text-sm font-semibold text-slate-700 mb-2">Internal Review Comment</label>
              <textarea
                id="route-review-comment"
                class="w-full bg-slate-50 border-slate-200 rounded-lg focus:border-primary focus:ring-primary px-3 py-2"
                rows="3"
                placeholder="Internal moderation note (visible to editors/admin)."
              ></textarea>
            </div>
          </div>
        </section>

        <section class="bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
          <div class="flex items-center gap-2 mb-6 border-b border-slate-100 pb-4">
            <span class="material-symbols-outlined text-primary">image</span>
            <h3 class="text-lg font-bold">Media</h3>
          </div>
          <div class="space-y-6">
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-2">Cover Image</label>
              <label for="route-cover-file" class="relative aspect-video rounded-lg bg-slate-100 border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-slate-400 group cursor-pointer hover:border-primary hover:bg-primary/5 transition-all">
                <span class="material-symbols-outlined text-3xl group-hover:text-primary transition-colors">cloud_upload</span>
                <span class="text-xs font-semibold mt-2 group-hover:text-primary transition-colors">Click to upload cover</span>
              </label>
              <input id="route-cover-file" type="file" class="hidden" accept="image/*"/>
              <p id="route-cover-file-name" class="mt-2 text-xs text-slate-500"></p>
              <div id="route-cover-preview" class="mt-2"></div>
            </div>
            <div>
              <label class="block text-sm font-semibold text-slate-700 mb-2">Gallery</label>
              <div class="grid grid-cols-2 md:grid-cols-4 gap-3">
                <label for="route-gallery-files" class="aspect-square rounded-lg border-2 border-dashed border-slate-200 flex items-center justify-center text-slate-400 hover:text-primary hover:border-primary cursor-pointer transition-colors">
                  <span class="material-symbols-outlined text-2xl">add</span>
                </label>
                <input id="route-gallery-files" type="file" class="hidden" accept="image/*" multiple/>
                <div id="route-gallery-preview" class="contents"></div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div class="lg:col-span-5 lg:sticky lg:top-24 space-y-6">
        <div class="bg-white rounded-xl border border-slate-200 shadow-lg overflow-hidden flex flex-col h-[700px]">
          <div class="p-4 border-b border-slate-100 flex items-center justify-between">
            <h3 class="font-bold flex items-center gap-2">
              <span class="material-symbols-outlined text-primary">map</span>
              Route Preview
            </h3>
            <div class="flex gap-2">
              <button class="p-1.5 rounded bg-slate-100 text-slate-600 hover:bg-primary hover:text-white transition-all" type="button">
                <span class="material-symbols-outlined text-base">layers</span>
              </button>
              <button class="p-1.5 rounded bg-slate-100 text-slate-600 hover:bg-primary hover:text-white transition-all" type="button">
                <span class="material-symbols-outlined text-base">my_location</span>
              </button>
            </div>
          </div>
          <div class="relative flex-1 bg-slate-100 overflow-hidden">
            <div class="absolute inset-0 flex items-center justify-center">
              <span class="text-sm text-slate-500">Map preview area</span>
            </div>
          </div>
          <div class="p-4 bg-slate-50">
            <div class="flex items-center justify-between text-xs text-slate-500 mb-2 font-bold uppercase tracking-wider">
              <span>Real-time Elevation Profile</span>
              <span>Total: preview</span>
            </div>
            <div class="h-16 w-full bg-slate-200 rounded"></div>
          </div>
        </div>
        <div class="p-4 rounded-xl border-2 border-dashed border-slate-300 flex flex-col items-center justify-center text-center py-8">
          <span class="material-symbols-outlined text-4xl text-slate-300 mb-2">upload_file</span>
          <p class="text-sm font-bold text-slate-600">Import GPX / KML File</p>
          <p class="text-xs text-slate-400 mt-1 px-4">Upload track data to automatically populate waypoints and metrics.</p>
          <button class="mt-4 text-xs font-bold text-primary border border-primary px-3 py-1.5 rounded-lg hover:bg-primary/5 transition-colors" type="button">Select File</button>
        </div>
      </div>
    </form>
  </div>

  <footer class="fixed bottom-0 left-64 right-0 bg-white border-t border-slate-200 py-4 px-6 md:px-10 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)] z-40">
    <div class="max-w-[1440px] mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
      <div class="flex items-center gap-4 text-slate-500 text-sm">
        <button class="hover:text-red-500 flex items-center gap-1 font-medium transition-colors" type="button">
          <span class="material-symbols-outlined text-lg">delete</span>
          Delete Route
        </button>
      </div>
      <div class="flex flex-wrap justify-center sm:justify-end items-center gap-3">
        <button id="route-cancel-btn" class="px-5 py-2.5 text-sm font-bold text-slate-600 hover:bg-slate-100 rounded-lg transition-colors" type="button">Cancel</button>
        <button id="route-import-json-btn" class="px-5 py-2.5 text-sm font-bold text-slate-600 bg-slate-100 hover:bg-slate-200 rounded-lg transition-colors inline-flex items-center gap-2" type="button">
          <span class="material-symbols-outlined text-sm">upload_file</span>
          Import JSON
        </button>
        <button id="route-save-draft-btn" class="px-5 py-2.5 text-sm font-bold text-primary bg-primary/10 hover:bg-primary/20 rounded-lg transition-colors" type="button">Save Draft</button>
        <button id="route-publish-btn" class="px-8 py-2.5 text-sm font-bold bg-primary text-white hover:bg-blue-600 rounded-lg shadow-lg shadow-primary/30 transition-all" type="button">Publish Route</button>
      </div>
    </div>
  </footer>
</main>
</div>
`;
